/* ============================================================
   Pod Nutrition — theme behaviour
   Shopify-aware: cart uses the AJAX Cart API.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.PODCFG || {};

  /* ---------------- money ---------------- */
  function money(cents) {
    var fmt = CFG.moneyFormat || '₹{{amount_no_decimals}}';
    var n = cents / 100;
    function fmtNum(v, dec, group) {
      var s = (Math.round(v * Math.pow(10, dec)) / Math.pow(10, dec)).toFixed(dec).split('.');
      var i = s[0], d = s[1];
      i = i.replace(/\B(?=(\d{2})+(\d{3})(?!\d))/g, group).replace(/(\d)(?=(\d{3})$)/, '$1' + group);
      return d ? i + '.' + d : i;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case 'amount': return fmtNum(n, 2, ',');
        case 'amount_no_decimals': return fmtNum(n, 0, ',');
        case 'amount_with_comma_separator': return fmtNum(n, 2, '.');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(n, 0, '.');
        default: return fmtNum(n, 0, ',');
      }
    });
  }
  window.podMoney = money;

  /* Escape Shopify/API strings before placing them into innerHTML. Product
     titles and recommendation URLs are merchant/content data and should not
     be trusted as HTML. */
  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#podToast');
    if (!el) { el = document.createElement('div'); el.id = 'podToast'; el.className = 'toast'; document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('on'); }, 2600);
  }
  window.podToast = toast;

  /* ---------------- overlay tracking (menu / cart / search) ----------------
     Lets CSS know when any full-screen overlay is open, so things that sit
     behind it (like the hero carousel's own arrows) can be force-hidden even
     in the sliver of viewport an overlay's own scrim doesn't fully opaque. */
  function overlayOpen() {
    var n = (+document.body.dataset.overlayCount || 0) + 1;
    document.body.dataset.overlayCount = n;
    document.body.classList.add('podOverlayOpen');
  }
  function overlayClose() {
    var n = Math.max(0, (+document.body.dataset.overlayCount || 0) - 1);
    document.body.dataset.overlayCount = n;
    if (!n) document.body.classList.remove('podOverlayOpen');
  }

  /* ---------------- ticker ---------------- */
  $$('[data-ticker]').forEach(function (t) {
    if (t.dataset.doubled) return;
    t.innerHTML = t.innerHTML + t.innerHTML;
    t.dataset.doubled = '1';
  });

  /* ---------------- slide-out menu ---------------- */
  function initMenu() {
    var m = $('#lmenu'), s = $('#mscrim');
    if (!m || !s) return;
    var open = function () { m.classList.add('on'); s.classList.add('on'); document.body.style.overflow = 'hidden'; overlayOpen(); };
    var close = function () { m.classList.remove('on'); s.classList.remove('on'); document.body.style.overflow = ''; overlayClose(); };
    $$('[data-menu-open]').forEach(function (b) { b.onclick = open; });
    $$('[data-menu-close]').forEach(function (b) { b.onclick = close; });
    s.onclick = close;
    $$('.lm-top', m).forEach(function (t) {
      var sec = t.closest('.lm-sec');
      if (!sec || !sec.querySelector('.lm-sub')) return;
      t.onclick = function () { sec.classList.toggle('open'); };
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------------- search ---------------- */
  function initSearch() {
    var wrap = $('#podSearch');
    if (!wrap) return;
    var open = function () { wrap.classList.add('on'); overlayOpen(); var i = $('input', wrap); if (i) setTimeout(function () { i.focus(); }, 60); };
    var close = function () { wrap.classList.remove('on'); overlayClose(); };
    $$('[data-search-open]').forEach(function (b) { b.onclick = open; });
    $$('[data-search-close]').forEach(function (b) { b.onclick = close; });
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------------- horizontal rails ---------------- */
  function wireRail(rail, prev, next) {
    if (!rail) return;
    var step = function () {
      var f = rail.firstElementChild;
      if (!f) return rail.clientWidth;
      var cs = getComputedStyle(rail);
      var g = parseFloat(cs.columnGap || cs.gap) || 14;
      return f.getBoundingClientRect().width + g;
    };
    var sync = function () {
      if (prev) prev.disabled = rail.scrollLeft < 8;
      if (next) next.disabled = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 8;
    };
    if (prev) prev.onclick = function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); };
    if (next) next.onclick = function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); };
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    /* click-and-drag (mouse/trackpad/pen) to scroll, in addition to native touch scrolling */
    var dragging = false, dragged = false, startX = 0, startScroll = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // let native touch scrolling handle this
      dragging = true; dragged = false;
      startX = e.clientX; startScroll = rail.scrollLeft;
      rail.classList.add('is-dragging');
    });
    rail.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) dragged = true;
      if (dragged) {
        rail.scrollLeft = startScroll - dx;
        e.preventDefault();
      }
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      rail.classList.remove('is-dragging');
      if (dragged) {
        /* suppress the click that would otherwise fire on the element under the
           pointer right after a drag (e.g. toggling a bundle pick unintentionally) */
        var suppress = function (ev) { ev.stopPropagation(); ev.preventDefault(); rail.removeEventListener('click', suppress, true); };
        rail.addEventListener('click', suppress, true);
        setTimeout(function () { rail.removeEventListener('click', suppress, true); }, 0);
      }
    }
    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener('pointerleave', function (e) { if (dragging && e.buttons === 0) endDrag(e); });
  }
  window.podWireRail = wireRail;

  function initRails() {
    $$('[data-rail]').forEach(function (rail) {
      if (rail.dataset.railWired) return;
      rail.dataset.railWired = '1';
      var scope = rail.closest('[data-rail-scope]') || document;
      wireRail(rail, $('[data-rail-prev]', scope), $('[data-rail-next]', scope));
    });
  }

  /* ---------------- hero carousel ---------------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var track = $('[data-hero-track]', hero);
      if (!track) return;
      var n = track.children.length;
      if (!n) return;
      var dots = $('[data-hero-dots]', hero);
      var i = 0, timer = null;
      var every = parseInt(hero.dataset.hero, 10) || 0;
      if (dots) {
        dots.innerHTML = '';
        for (var k = 0; k < n; k++) {
          var b = document.createElement('button');
          b.type = 'button'; b.dataset.i = k;
          b.setAttribute('aria-label', 'Slide ' + (k + 1));
          b.appendChild(document.createElement('i'));
          dots.appendChild(b);
        }
      }
      function go(k, restart) {
        i = (k + n) % n;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        if (dots) Array.prototype.forEach.call(dots.children, function (x, z) {
          x.setAttribute('aria-pressed', z === i);
          var bar = x.querySelector('i');
          if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; if (z === i) bar.style.animation = ''; }
        });
        Array.prototype.forEach.call(track.children, function (s, z) { s.setAttribute('aria-hidden', z !== i); });
        if (restart !== false) start();
      }
      function start() { if (!every || n < 2) return; clearInterval(timer); timer = setInterval(function () { go(i + 1, false); }, every); }
      if (dots) dots.onclick = function (e) { var b = e.target.closest('button'); if (b) go(+b.dataset.i); };
      var pv = $('[data-hero-prev]', hero), nx = $('[data-hero-next]', hero);
      if (pv) pv.onclick = function () { go(i - 1); };
      if (nx) nx.onclick = function () { go(i + 1); };
      hero.addEventListener('mouseenter', function () { clearInterval(timer); });
      hero.addEventListener('mouseleave', start);
      /* touch swipe */
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      }, { passive: true });
      go(0);
    });
  }

  /* ---------------- reveal on scroll + sticky header ---------------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) { $$('.rv').forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
    $$('.rv').forEach(function (el) { if (!el.classList.contains('in')) io.observe(el); });
  }

  function initScroll() {
    var hdr = $('#hdr');
    var sticky = $('#pstick') || $('#sticky');
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (hdr) hdr.classList.toggle('stuck', y > 10);
      if (sticky) sticky.classList.toggle('on', y > (parseInt(sticky.dataset.after, 10) || 560));
    }, { passive: true });
  }

  /* ============================================================
     CART — Shopify AJAX Cart API
     ============================================================ */
  var CART = { items: [], total_price: 0, item_count: 0 };
  var lastRecoProductId = null;

  /* Keep cart state simple and deterministic. Shopify is the source of truth;
     every mutation refreshes /cart.js and immediately renders that response. */
  var cartAppliedAt = 0;
  function applyCart(startedAt, cart) {
    if (!cart) return;
    cartAppliedAt = startedAt || Date.now();
    CART = cart;
    renderCart();
  }
  window.podApplyCart = applyCart;

  function cartFetch(url, body) {
    var opts = { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (body) opts.body = JSON.stringify(body);
    return fetch(CFG.routes && CFG.routes[url] ? CFG.routes[url] : url, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
        return j;
      });
    });
  }

  function getCart() { return cartFetch((CFG.routes && CFG.routes.cart) || '/cart.js'); }

  function addItems(items) {
    var startedAt = Date.now();
    return cartFetch((CFG.routes && CFG.routes.cartAdd) || '/cart/add.js', { items: items })
      .then(function () { return getCart(); })
      .then(function (c) { applyCart(startedAt, c); return c; });
  }
  window.podAdd = function (variantId, qty, title) {
    if (!variantId) { toast('Pick an option first'); return Promise.resolve(); }
    return addItems([{ id: Number(variantId), quantity: qty || 1 }])
      .then(function () { toast(title ? 'Added — ' + title : 'Added to cart'); openCart(); })
      .catch(function (e) { toast(e.message || 'Could not add that'); });
  };
  window.podAddMany = function (items, msg) {
    return addItems(items)
      .then(function () { toast(msg || 'Added to cart'); openCart(); })
      .catch(function (e) {
        toast(e.message || 'Could not add that');
        throw e;
      });
  };

  function changeLine(line, qty) {
    var startedAt = Date.now();
    return cartFetch((CFG.routes && CFG.routes.cartChange) || '/cart/change.js', { line: line, quantity: qty })
      .then(function (c) { applyCart(startedAt, c); })
      .catch(function (e) { toast(e.message || 'Could not update the cart'); });
  }

  function clearCart() {
    var startedAt = Date.now();
    return cartFetch('/cart/clear.js', {})
      .then(function (c) { applyCart(startedAt, c); })
      .catch(function (e) { toast(e.message || 'Could not clear the cart'); });
  }

  /* The homepage "Buy 2 Get 1" bundle (sections/pod-bundle.liquid) adds its three
     lines straight to /cart/add.js itself, deliberately independent of this file's
     load order (see that section's own script comment) — so it never touches this
     module's CART variable or calls renderCart() directly. It dispatches a
     `pod:cart-updated` custom event with the fresh cart payload and the Date.now()
     timestamp of when ITS OWN request started, once Shopify's cart is updated.
     Route it through applyCart() (not a raw assignment) so it takes part in the
     same started-at ordering as every other cart-mutating flow above — otherwise
     this listener could itself be the one clobbering a fresher result with a
     stale one, or have its own good result thrown away by a stale one landing
     after it. */
  document.addEventListener('pod:cart-updated', function (e) {
    if (!e || !e.detail) return;
    var detail = e.detail;
    var cart = detail && detail.cart ? detail.cart : detail;
    var startedAt = (detail && detail.startedAt) || Date.now();
    applyCart(startedAt, cart);
  });

  /* ---------------- "You may also like" cart recommendations ----------------
     Uses Shopify's public recommendations JSON endpoint (independent of any
     particular section), keyed off the first line item's product. Refetches
     whenever the cart's first product changes, and hides itself cleanly when
     there's nothing to show or the request fails. Each item also gets its own
     quick "add" button directly below its image (see the delegated click
     handler wired in initCart()) so shoppers don't have to leave the drawer
     to add one. */
  function loadRecommendations(productId) {
    var wrap = $('#cartReco'), rail = $('#cartRecoRail');
    if (!wrap || !rail) return;
    if (!productId) { wrap.hidden = true; lastRecoProductId = null; return; }
    if (productId === lastRecoProductId) return;
    lastRecoProductId = productId;
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) { wrap.hidden = true; return; }
        rail.innerHTML = products.slice(0, 6).map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var url = p.url || ('/products/' + p.handle);
          url = String(url || '');
          if (!/^\//.test(url) || /^\/\//.test(url)) url = '/products/' + encodeURIComponent(p.handle || '');
          var vid = (p.variants && p.variants.length) ? p.variants[0].id : '';
          var avail = (p.variants && p.variants.length) ? (p.variants[0].available !== false) : !!p.available;
          return '<div class="dreco-item">'
            + '<a class="dreco-link" href="' + esc(url) + '">'
            + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="th"></span>')
            + '<span class="dreco-t">' + esc(p.title) + '</span>'
            + '<span class="dreco-p">' + money(p.price) + '</span>'
            + '</a>'
            + (vid && avail ? '<button type="button" class="dreco-add" data-vid="' + esc(vid) + '" data-title="' + esc(p.title) + '" aria-label="Add ' + esc(p.title) + ' to cart">Add</button>' : '')
            + '</div>';
        }).join('');
        wrap.hidden = false;
      })
      .catch(function () { wrap.hidden = true; });
  }

  function renderCart() {
    var n = CART.item_count || 0;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('on', n > 0); });
    var items = $('#cartItemsList');
    if (items) {
      items.innerHTML = (CART.items && CART.items.length)
        ? CART.items.map(function (it, idx) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
          var opts = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
            .map(function (o) { return o.value; }).join(' · ');
          return '<div class="ditem">'
            + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56">' : '<span class="ph"></span>')
            + '<div><b>' + esc(it.product_title) + '</b><span>' + esc(opts || '') + '</span>'
            + '<span class="qrow"><button type="button" data-line="' + (idx + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">&minus;</button>'
            + '<em>' + it.quantity + '</em>'
            + '<button type="button" data-line="' + (idx + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></span></div>'
            + '<div class="amt">' + money(it.final_line_price) + '</div>'
            + '<button type="button" class="rm" data-line="' + (idx + 1) + '" data-remove="1" aria-label="Remove item"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>';
        }).join('')
        : '<div class="dempty">Nothing here yet.<br>Add something and watch this fill up.</div>';
      $$('button[data-line]', items).forEach(function (b) {
        b.onclick = function () {
          if (b.dataset.remove) { changeLine(+b.dataset.line, 0); }
          else { changeLine(+b.dataset.line, Math.max(0, +b.dataset.q)); }
        };
      });
    }
    var tot = $('#cartTotal'); if (tot) tot.textContent = money(CART.total_price || 0);
    var goal = Number(CFG.freeShipping || 0);
    var bar = $('#shipBar'), msg = $('#shipMsg'), wrap = $('#shipWrap');
    if (msg) msg.hidden = goal <= 0;
    if (wrap) wrap.hidden = goal <= 0;
    if (goal > 0 && bar) bar.style.width = Math.min(100, (CART.total_price / goal) * 100) + '%';
    if (goal > 0 && msg) {
      msg.innerHTML = CART.total_price >= goal
        ? '<b style="color:var(--acc)">&#10003; Free shipping unlocked</b>'
        : 'Add ' + money(goal - CART.total_price) + ' more for free shipping';
    }
    var foot = $('#cartFoot'); if (foot) foot.hidden = !(CART.items && CART.items.length);
    if (CART.items && CART.items.length) {
      loadRecommendations(CART.items[0].product_id);
    } else {
      var recoWrap = $('#cartReco'); if (recoWrap) recoWrap.hidden = true;
      lastRecoProductId = null;
    }
  }

  function openCart() {
    var d = $('#drawer'); if (!d) { location.href = (CFG.routes && CFG.routes.cartPage) || '/cart'; return; }
    d.classList.add('on'); $('#scrim').classList.add('on');
    /* Lock background scroll while the drawer is open — mirrors initMenu()'s
       slide-out menu behaviour. Without this, touch-scrolling on mobile
       scrolls the page underneath the fixed drawer (iOS Safari in particular
       fights the drawer's own internal scroll/rubber-bands the whole page),
       which is what made the cart feel broken/unresponsive on phones even
       though desktop — where a stray scroll gesture isn't in the way — was
       fine. */
    document.body.style.overflow = 'hidden';
    overlayOpen();
  }
  function closeCart() {
    var d = $('#drawer'); if (!d) return;
    d.classList.remove('on'); var s = $('#scrim'); if (s) s.classList.remove('on');
    document.body.style.overflow = '';
    overlayClose();
  }
  window.podOpenCart = openCart;

  function initCart() {
    $$('[data-cart-open]').forEach(function (b) { b.onclick = function (e) { e.preventDefault(); openCart(); }; });
    $$('[data-cart-close]').forEach(function (b) { b.onclick = closeCart; });
    var s = $('#scrim'); if (s) s.onclick = closeCart;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    var clearBtn = $('#clearCartBtn');
    if (clearBtn && !clearBtn.dataset.wired) { clearBtn.dataset.wired = '1'; clearBtn.onclick = clearCart; }
    /* Delegated "add to cart" for the "You may also like" rail — wired once,
       since loadRecommendations() replaces the rail's innerHTML on every
       refresh and any per-button listener would be lost each time. */
    var recoRail = $('#cartRecoRail');
    if (recoRail && !recoRail.dataset.wired) {
      recoRail.dataset.wired = '1';
      recoRail.addEventListener('click', function (e) {
        var b = e.target.closest('.dreco-add');
        if (!b || b.disabled) return;
        e.preventDefault();
        b.disabled = true;
        window.podAdd(b.dataset.vid, 1, b.dataset.title).then(function () { b.disabled = false; });
      });
    }
    if (window.PODCART) { applyCart(Date.now(), window.PODCART); }
    var bootStartedAt = Date.now();
    getCart().then(function (c) { applyCart(bootStartedAt, c); }).catch(function () { });
  }

  /* ---------------- product cards: variant + add ---------------- */
  function paintCard(card) {
    var sel = card.querySelector('.pill[aria-pressed="true"]') || card.querySelector('.pill');
    var data;
    try {
      data = sel ? JSON.parse(sel.dataset.v || '{}') : JSON.parse(card.dataset.v || '{}');
    } catch (e) {
      console.error('[Pod] Invalid product-card variant data', e);
      return;
    }
    var money$ = card.querySelector('[data-money]');
    var meta = card.querySelector('[data-meta]');
    var btn = card.querySelector('[data-atc]');
    if (money$) {
      money$.innerHTML = '<span class="now">' + money(data.p) + (data.was && data.was > data.p ? '<s>' + money(data.was) + '</s>' : '') + '</span>'
        + (data.s ? '<span class="ps">' + money(Math.round(data.p / data.s)) + ' / serving</span>' : '');
    }
    if (meta) {
      /* Piece-count / stock-left messaging intentionally not shown below the image. */
      var right = (data.was && data.was > data.p)
        ? '<span class="off">' + Math.round((1 - data.p / data.was) * 100) + '% off</span>'
        : (data.s ? '<span class="off">' + data.s + ' servings</span>' : '');
      meta.innerHTML = right;
    }
    if (btn) {
      btn.dataset.id = data.id || '';
      var span = btn.querySelector('span');
      if (data.q > 0 || data.cont) {
        span.textContent = 'Add to cart';
        btn.classList.add('acc'); btn.classList.remove('ghost'); btn.disabled = false;
      } else {
        span.textContent = 'Out of stock';
        btn.classList.remove('acc'); btn.classList.add('ghost'); btn.disabled = true;
      }
    }
  }

  function initCards() {
    $$('.pc').forEach(function (card) {
      if (card.dataset.wired) return;
      card.dataset.wired = '1';
      var pills = $$('.pill', card);
      pills.forEach(function (p) {
        p.onclick = function () {
          pills.forEach(function (x) { x.setAttribute('aria-pressed', x === p); });
          paintCard(card);
        };
      });
      if (pills.length && !card.querySelector('.pill[aria-pressed="true"]')) {
        var first = pills.filter(function (p) { return !p.disabled; })[0] || pills[0];
        first.setAttribute('aria-pressed', 'true');
      }
      var btn = card.querySelector('[data-atc]');
      if (btn) btn.onclick = function () { window.podAdd(btn.dataset.id, 1, card.dataset.title); };
      paintCard(card);
    });
  }
  window.podInitCards = initCards;

  /* ---------------- boot ---------------- */
  function boot() {
    [initMenu, initSearch, initRails, initHero, initReveal, initScroll, initCart, initCards].forEach(function (init) {
      try { init(); } catch (e) { console.error('[Pod] Initializer failed:', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* theme editor re-render hooks */
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', initReveal);
})();
